<template>
  <div>
    <MasterLayout>
      <section class="section__row topmost-margin radius-5 align-items-center">
        <div class="row">
          <div class="col-md-7">
            <h4>Stock valuation</h4>
          </div>
          <div class="col-md-3"></div>
        </div>
      </section>
      <section
        class="products_summary__wrapper mt-3"
        v-if="
          !productsValuation || (productsValuation.length < 1 && !showLoader)
        "
      >
        <div
          class="empty_tank_wrapper"
          style="
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column wrap;
          "
        >
          <div class="text-center" style="margin-top: 100px">
            <h6 style="color: rgb(161, 146, 146)">
              {{$t('text.products.noStockValuation')}}
            </h6>
          </div>

          <div class="text-cente pb-5" style="margin-top: 20px">
            <h3 style="color: rgb(161, 146, 146); font-size: 25px"></h3>
          </div>
        </div>
      </section>
      <section
        class="row card-loader-wrapper w-100"
        v-if="showLoader"
        style="margin-top: 0px"
      >
        <div
          class="col-md-3 mt-3 position-relative"
          v-for="(c, i) in 8"
          :key="i"
        >
          <div class="card-loader"></div>
        </div>
      </section>
      <section class="section__row mt-3 row ml-0" v-if="!showLoader">
        <div
          v-for="(prodVal, i) in productsValuation"
          :key="i"
          class="w-100 col-md-4 mb-3"
        >
          <div
            class="ep-card p-3"
            style="border-radius: 17px"
            :style="{
              backgroundImage: `url(${cardBackgroundUrl})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right',
              backgroundSize: ' 136px',
            }"
          >
            <div class="card__header___text">
              <div class="w-100">
                <h3 class="our_branches__header">{{ prodVal.productName }}</h3>
                <div class="dealer__icon__wrapper mt-3">
                  <div
                    :class="[
                      prodVal.productName.toLowerCase() === 'pms'
                        ? 'oil_drop_div_1'
                        : prodVal.productName.toLowerCase() === 'ago'
                        ? 'oil_drop_div_2'
                        : prodVal.productName.toLowerCase() === 'dpk'
                        ? 'oil_drop_div_3'
                        : prodVal.productName.toLowerCase() === 'lpg'
                        ? 'oil_drop_div_5'
                        : null,
                    ]"
                  >
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <h3> {{$t('text.products.currentVolume')}}</h3>
                  </div>
                  <div class="col-md-6 text-right">
                    <h3>{{ convertThousand(prodVal.currentVolume) }} {{$t('text.products.ltrs')}}</h3>
                  </div>
                </div>
                <div class="row mt-3 align-items-center justify-content-center">
                  <div class="col-md-6">
                    <h3> {{$t('text.products.val')}}</h3>
                  </div>
                  <div class="col-md-6 text-right">
                    <h3>
                      {{ group ? group.currencyCode : ""
                      }}{{ convertThousand(prodVal.valuation) }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/groupManagement/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  groupAggregates,
} from "@syncfusion/ej2-vue-grids";
import Paginator from "@/components/Paginator.vue";
import VueMomentsAgo from "vue-moments-ago";
import DropDown from "@/components/Templates/Dropdown/branchesDropdown.vue";
import Temp from "@/components/Templates/branchesListTemplate.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";

import Jquery from "jquery";
let $ = Jquery;

export default {
  title: "Expenses:: Epump Portal",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
    VueMomentsAgo,
    DropDown,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      groupId: null,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      categories: [],
      category: "all",
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(30, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(30, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      totalExpenses: 0,
      totalIncome: 0,
      expensesCount: 0,
      backgroundUrl,
      cardBackgroundUrl,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      companyExpenses: [],
      showLoader: true,
      groupedExpense: [],
      companyExpenses: [],
      productsValuation: [],
      group: null,
    };
  },
  computed: {},
  mounted() {
    this.$eventHub.$on("group", (group) => {
      this.group = group;
    });
    if (this.$route.query.groupId) {
      this.getProductsValuation();
    }
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    Array.from(document.getElementsByTagName("input")).forEach((input) => {
      if (!Array.from(input.classList).includes("form-control")) {
        input.classList.add("form-control");
      }
    });
  },
  created() {
    this.$eventHub.$on("group", (group) => {
      this.group = group;
    });
    if (this.$route.query.groupId) {
      this.getProductsValuation();
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  watch: {
    group(group) {
      if (group !== null) {
        this.getProductsValuation();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getProductsValuation();
      }
    },
  },
  methods: {
    getProductsValuation() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/GroupStockValuationReport/${
            this.$route.query.groupId
              ? this.$route.query.groupId
              : this.group.id
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          this.productsValuation = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
          this.$toast(error.response.data.message, {
            type: "error",
            timeout: 3000,
          });
        });
    },
    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      const value = seconds < 0 ? "from now" : "ago";
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ") +
          value
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ") +
          value
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ") +
          value
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ") +
          value
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ") +
          value
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ") +
        value
      );
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "branches.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
